import { Component, ElementRef, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AuthAccessProvider } from "app/core/core.auth";
import { BaseComponent, User, UserContext, UserData } from "app/core/core.component";
import { BusyProvider } from "app/service/busy.service";
import { GestioneGruppiService } from "app/service/gestione-gruppi.service";
import { MessageProvider } from "app/service/message.service";
import { UserService } from "app/service/user.service";
import { UsersComponent } from "app/users/users.component";
import { Message } from "primeng/components/common/api";
import { Subscription } from "rxjs";

declare var $: any;

@Component({
  selector: "app-gestione-gruppi",
  templateUrl: "./gestione-gruppi.component.html",
  styleUrls: ["./gestione-gruppi.component.css"]
})

export class GestioneGruppiComponent
  extends BaseComponent
  implements OnInit, OnDestroy {
  static DIALOG_ID = "GestioneGruppiDialog";
  @Output() messaggio = new EventEmitter<User>();

  userContext: UserContext;
  user: User;
  userData = new UserData();
  errorMessage: string;
  validationMessage: string;
  loading = false;
  uc: UsersComponent;

  gruppi: { label: string }[] = [];
  showLogin: boolean = false;
  loginUsername: string = null;
  password: string = null;
  selectedGruppi: string[] = [];

  initialGruppi: string[] = [];
  gruppiAssegnati = "Nessuno";

  msgs: Message[] = [];
  cambioGruppo = false;
  private subscriptions: Subscription[] = [];

  constructor(
    protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private gestioneGruppiService: GestioneGruppiService,
    private userService: UserService,
    private busyProvider: BusyProvider
  ) {
    super(authAccess, router, messageProvider);
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (!this.userContext) {
      this.authAccess.invalidate();
      return;
    }

    const statusSub = this.gestioneGruppiService
      .gestioneGruppiComponentStatus$
      .subscribe((u: User) => {
        if (u) {
          this.user = u; // ← assegna l'utente
          this.loadgruppi(); // ← carica i gruppi
          $("#" + GestioneGruppiComponent.DIALOG_ID).modal("show"); // ← apre il modale
        }
      });

    this.subscriptions.push(statusSub);
  }
  onGruppiChange() {
    const stessiElementi =
      this.selectedGruppi.length === this.initialGruppi.length &&
      this.selectedGruppi.every(g => this.initialGruppi.includes(g));

    this.cambioGruppo = !stessiElementi;
  }

  loadgruppi() {
    this.gruppi = [];
    this.selectedGruppi = [];

    this.userService.getGruppiLDAP(this.userContext.srmToken).subscribe(
      (result) => {
        this.gruppi = result.gruppi
          .sort((a, b) => a.nome.localeCompare(b.nome))
          .map(g => ({ label: g.nome, value: g.nome }));

        // ora carica i gruppi dell'utente specifico e preselezionali
        this.gestioneGruppiService.getUserGruppi(this.userContext.srmToken, this.user).subscribe(
          (userGruppi) => {
            const nomiGruppiUtente = userGruppi.gruppi.map(g => g.nome);
            this.selectedGruppi = this.gruppi
              .filter(g => nomiGruppiUtente.includes(g.label))
              .map(g => g.label);
            this.initialGruppi = [...this.selectedGruppi]; // ← snapshot iniziale
            this.cambioGruppo = false;
          },
          (error) => { this.handleError(error); }
        );
      },
      (error) => { this.handleError(error); }
    );
  }

  ngOnDestroy() {
    for (const sub of this.subscriptions) {
      sub.unsubscribe();
    }
  }

  close() {
    $("#" + GestioneGruppiComponent.DIALOG_ID).modal("hide");
    this.resetState();
  }

  save() {
    this.showLogin = true;
  }

  modificaGruppi() {
    $("#" + GestioneGruppiComponent.DIALOG_ID).modal("hide");
    this.busyProvider.showBusyIndicator();
    this.gestioneGruppiService.changeGruppi(this.userContext.srmToken, this.user, this.selectedGruppi, this.loginUsername, this.password).subscribe(
      (result) => {
        this.busyProvider.hideBusyIndicator();
        this.messaggio.emit(this.user);
        this.resetState();
      },
      (error) => {
        this.busyProvider.hideBusyIndicator();
        this.handleError(error);
        this.resetState();
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    );
  }

  closeLogin() {
    this.showLogin = false;
    this.close();
    this.resetState;
  }

  private resetState() {
    this.user = null;
    this.userData = new UserData();
    this.errorMessage = null;
    this.validationMessage = null;
    this.loading = false;
    //this.uffici = [];
    this.showLogin = false;
    this.loginUsername = null;
    this.password = null;
    this.selectedGruppi = [];
  }

}



// WEBPACK FOOTER //
// ./src/app/gestione-gruppi/gestione-gruppi.component.ts